import { SELECTED_CONTINUITY_POLICY } from '../policies/selectedContinuity.policy.js';

/** Socket.IO owns ACK callback/timer cleanup on timeout and disconnect. */
export function emitSelectedRequest(socket, event, payload, reply) {
  if (!socket?.connected || typeof socket.timeout !== 'function') { reply(null); return false; }
  try {
    socket.timeout(SELECTED_CONTINUITY_POLICY.transportAckTimeoutMs).emit(event, payload,
      (error, result) => reply(error ? null : result));
    return true;
  } catch { reply(null); return false; }
}
